import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { DropdownBodyWrapper } from './wrappers';
import { FitRelativeWrapper } from 'wrappers';
import { SelectorButton } from './atoms';
import React from 'react';
import internalState from './internalState';
import wrapTooltip from 'wrappers/tooltip';
import { CategoryDropdown } from './containers';

const containerRef = React.createRef();

export const definition = {
  name: 'ParentCategoryDropdown',
  controller: Controller,
  initialProps: ({ categories, selectedCategoryId, selectedParentId, isOpen }) => ({ isOpen, categories, selectedCategoryId, selectedParentId, containerRef }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: '__transparent__',
      ref: containerRef,
      elements: [
        wrapTooltip(
          {
            component: SelectorButton,
            tooltip: { content: 'Change category', direction: 'top' },
            name: 'Selector',
            bindings: ({ isOpen }) => ({ isOpen, containerRef }),
            displayValue: ({ categories, selectedParentId }) => {
              let category = categories.find(c => c.id === selectedParentId);
              return category?.name ?? 'Category'
            }
          }
        ),
        {
          wrapper: DropdownBodyWrapper,
          name: 'Body',
          renderIf: ({ isOpen }) => isOpen,
          elements: [
            {
              component: CategoryDropdown,
              name: 'Category',
              isListOf: 'categories',
              bindings: ({ category, selectedCategoryId, selectedParentId }) => ({ category, selectedCategoryId, selectedParentId })
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);